import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { env } from '@amfam/environment';
import { LifePolicy } from '@amfam/policy/models/lib/models/life-policy';
import { Life, LifeDetail } from '@amfam/policy/models/lib/models/life.model';
import { PolicySummary } from '@amfam/policy/models/lib/models/policy-summary';
import { PolicySharedService } from '@amfam/policy/shared/lib/services/policy-shared.service';

import { TypedWorker } from './typed-worker';

@Injectable({
  providedIn: 'root'
})
export class LifeService implements TypedWorker {
  private http = inject(HttpClient);

  private policySharedService = inject(PolicySharedService);
  private policyStatusCodes = ['A', 'E', 'G', 'J', 'K', 'P', 'Q', 'U', 'W'];
  private productTypes = ['TERM', 'WHOLE LIFE', 'SPT', 'UL-MYLIFE', 'UNKNOWN'];

  /**
   * @description: Returns the productApi endpoint for lifepolicies.
   */
  public getEndpoint() {
    return env.policyExperienceApi + 'product/lifepolicies/';
  }

  public getPolicy(url: string, policySummary: PolicySummary): Observable<LifePolicy> {
    const headers = this.policySharedService.getPolicyPartnerIdHeader(
      policySummary.policyPartnerId
    );

    return this.http
      .get<LifeDetail>(url, { headers })
      .pipe(map(data => this.loadModel(data, policySummary)));
  }

  public loadModel(json: LifeDetail, policySummary: PolicySummary): LifePolicy {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let policy: any = json;
    if (json.policy) {
      policy = json.policy;
    }

    // Rules to determine active life policy.
    if (
      this.policyStatusCodes.includes((policy?.policyStatus ?? '').toUpperCase()) &&
      this.productTypes.includes((policy?.productType ?? '').toUpperCase())
    ) {
      policy = {
        ...policy,
        ...policySummary,
        term: policy.productType,
        effectiveDate: policy.effectiveDate || policySummary.effectiveDate
      };

      return new LifePolicy({ ...policy, sourceSystem: policySummary.sourcePath });
    }
    return new LifePolicy({} as Life);
  }
}
